import { api } from './http';

export interface DevicePushEndpointProof {
  endpoints: string[];
  resolved: boolean;
}

/** Decisive server-side logout for every session/push row on this device. */
export async function logoutDevice(proof: DevicePushEndpointProof): Promise<boolean> {
  const response = await api.post('/auth/device/logout', {
    push_endpoints: proof.endpoints,
    push_endpoints_resolved: proof.resolved,
  });
  return response.headers?.['x-valentine-legacy-alerts-retired'] === 'true';
}

/** Rotate this installation identity after revoking only this physical device. */
export async function resetDeviceInstallation(proof: DevicePushEndpointProof): Promise<boolean> {
  const response = await api.post('/auth/device/reset', {
    push_endpoints: proof.endpoints,
    push_endpoints_resolved: proof.resolved,
  });
  return response.headers?.['x-valentine-legacy-alerts-retired'] === 'true';
}
